import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  fetchCityName,
  Loader,
  utils,
} from '@resy/ui-kitchen';
import DeltaWifiBookNow from './DeltaWifiBookNow';
import DeltaWifiCitySelector from './DeltaWifiCitySelector';
import DeltaWifiFooter from './DeltaWifiFooter';
import DeltaWifiBanner from './DeltaWifiBanner';
import DeltaWifiEditorial from './DeltaWifiEditorial';
import DeltaWifiIntroBanner from './DeltaWifiIntroBanner';
import DeltaWifiAlgorithmicLists from './DeltaWifiAlgorithmicLists';
import DeltaWifiFeaturedVenues from './DeltaWifiFeaturedVenues';
import DeltaWifiGDAVenues from './DeltaWifiGDAVenues';
import { fetchLeaderboards } from '../../../../../ui-kitchen/src/reducers/collectionsSlice';
import { getResyLocationsByCodeThunk } from '../../../../../ui-kitchen/src/reducers/resyLocationsSlice';
import { ALL_DAY } from '../../../../../ui-kitchen/src/constants/resyCore';
import { selectIsGlobalDiningAccess } from '../../../../../ui-kitchen/src/reducers/userSlice';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import './DeltaWifiResyNav.scss';
import './DeltaWifi.scss';
import { setAgnosticCity } from '../../../../../ui-kitchen/src/reducers/amexDeltaWifiSlice';

class DeltaWifi extends React.Component {
  static propTypes = {
    $location: PropTypes.shape({
      path: PropTypes.func,
    }).isRequired,
    ResyAmexConfig: PropTypes.shape({
      baseRequestUrl: PropTypes.string.isRequired,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
    city: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
      error: PropTypes.string,
    }),
    Analytics: PropTypes.shape({
      event: PropTypes.func,
      page: PropTypes.func,
    }).isRequired,
    $rootScope: PropTypes.shape(PropTypes.object.isRequired).isRequired,
    selectedDate: PropTypes.string.isRequired,
    selectedTime: PropTypes.string,
    selectedSeats: PropTypes.number,
    isMobile: PropTypes.bool,
    latLng: PropTypes.shape({
      value: PropTypes.string,
    }),
    loadNotifyModal: PropTypes.func.isRequired,
    locationCode: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired,
    setDeltaPageLocation: PropTypes.func.isRequired,
    showSignupModal: PropTypes.func.isRequired,
    onLogin: PropTypes.func.isRequired,
    matchMedia: PropTypes.shape({
      xs: PropTypes.bool,
      sm: PropTypes.bool,
      md: PropTypes.bool,
      lg: PropTypes.bool,
      xl: PropTypes.bool,
    }).isRequired,
    collections: PropTypes.arrayOf(PropTypes.object),
    userIsGda: PropTypes.bool.isRequired,
    showAuthModal: PropTypes.func.isRequired,
    agnosticCity: PropTypes.shape({}),
  }

  static defaultProps = {
    isMobile: false,
    latLng: null,
    locationCode: 'ny',
    selectedSeats: 2,
    selectedTime: null,
    city: {},
    collections: [],
    agnosticCity: {},
  };

  state = {
    dataContent: {},
    editorialAgnostic: null,
    editorialMarket: null,
    slug: '',
  }

  async componentDidMount() {
    const {
      $location, ResyAmexConfig: {
        baseRequestUrl,
      },
      dispatch,
    } = this.props;
    dispatch(fetchCityName(baseRequestUrl, $location.path()));
    this.fetchConfig();

    this.checkShowSignupModal();
  }

  async componentDidUpdate(prevProps) {
    const {
      city, dispatch, $location, Analytics, agnosticCity,
    } = this.props;

    const { slug } = this.state;

    if (slug) {
      dispatch(fetchLeaderboards({
        locationSlug: slug,
        limit: 5,
      }));
    }

    if (city && prevProps.city !== city) {
      const { code } = city;
      this.resetLocation(code);
    }
    if (prevProps.city !== city && !agnosticCity) {
      if (this.isMarketAgnosticWithCity()) {
        this.fetchAgnosticEditorial();
        const { city: { error } } = this.props;
        if (error) {
          const pageName = 'Delta Wifi Agnostic';
          const { referrer } = window.document;
          const metadata = {};
          metadata.pageName = pageName;
          Analytics.page($location, referrer, metadata);
        }
      } else {
        const { city: { code, name = 'city' } } = this.props;
        this.fetchMarketEditorial(code);
        const pageName = `Delta Wifi ${name}`;
        const { referrer } = window.document;
        const metadata = {};
        metadata.pageName = pageName;
        Analytics.page($location, referrer, metadata);
      }
    }
  }

  fetchConfig = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    const dataEndPoint = `${baseRequestUrl}DeltaWifi/DeltaWifiData.json`;
    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const dataContent = await dataResponse.json();
      this.setState({ dataContent });
    } catch (err) {
      Logger.error('[DeltaWifi] DeltaWifiData JSON File Error:', err);
    }
  }

  fetchAgnosticEditorial = async () => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;

    const dataEndPoint = `${baseRequestUrl}DeltaWifi/editorialData/agnostic/agnostic_editorial.json`;

    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const editorialAgnostic = await dataResponse.json();
      this.setState({ editorialAgnostic });
    } catch (err) {
      Logger.error('[DeltaWifi] DeltaWifiData JSON File Error:', err);
    }
  }

  fetchMarketEditorial = async (cityCode) => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
    } = this.props;
    const dataEndPoint = `${baseRequestUrl}DeltaWifi/editorialData/market/${cityCode}_editorial.json`;

    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const editorialMarket = await dataResponse.json();
      this.setState({ editorialMarket });
    } catch (err) {
      Logger.error('[DeltaWifi] DeltaWifiData JSON File Error:', err);
    }
  }

  isMarketAgnosticWithCity = () => {
    let isAgnostic = true;
    const { $location, city } = this.props;
    const locationPath = $location.path();
    const pathArr = locationPath.split('/');
    let urlPathValue = '';
    if (pathArr.length === 3) {
      [, , urlPathValue] = pathArr;
      if (urlPathValue && city?.code) {
        isAgnostic = false;
      }
    }
    return isAgnostic;
  }

  resetLocation = async (code) => {
    const {
      dispatch,
      setDeltaPageLocation,
    } = this.props;
    const locationCode = code || 'chi';
    const cityLocation = await dispatch(getResyLocationsByCodeThunk(locationCode));
    const locationTemp = {
      code: locationCode,
      hideMenu: true,
      name: null,
      slug: '',
    };
    this.setState({ slug: cityLocation ? cityLocation?.url_slug : locationTemp?.slug });
    setDeltaPageLocation(cityLocation || locationTemp);
  }

  fetchBookNowForAgnostic = (city) => {
    const { dispatch } = this.props;
    const { code } = city;
    this.resetLocation(code);
    dispatch(setAgnosticCity(city));
  }

  displayEditorialContents = (contents) => {
    if (!contents) return null;
    if (contents.length === 4 || contents.length === 3) {
      return contents.sort((a, b) => a.id - b.id);
    } if (contents.length > 4) {
      return contents.sort((a, b) => a.id - b.id).slice(0, 4);
    }
    return null;
  }

  getAgnosticEditorialContents = (blogId) => {
    const { editorialAgnostic } = this.state;
    let { contents: blogEditorialContent } = (editorialAgnostic ? editorialAgnostic?.blogs?.find((blog) => blog.id === blogId) : {});
    blogEditorialContent = this.displayEditorialContents(blogEditorialContent);
    return blogEditorialContent;
  }

  getMarketEditorialContents = () => {
    const { editorialMarket } = this.state;
    let { contents: marketEditorialContent } = editorialMarket ? editorialMarket?.blogs?.[0] : {};
    marketEditorialContent = this.displayEditorialContents(marketEditorialContent);
    return marketEditorialContent;
  }

  getIntroEditorialContents = (isAgnostic) => {
    const { editorialAgnostic, editorialMarket } = this.state;
    if (isAgnostic) return editorialAgnostic?.hitlist || {};
    return editorialMarket?.hitlist || {};
  }

  checkShowSignupModal = () => {
    const { showSignupModal } = this.props;
    const isSignUp = utils.getQueryVariable('signup');

    if (isSignUp === 'true') {
      showSignupModal();
    }
  };

  login = () => {
    const { onLogin } = this.props;
    onLogin('delta');
  }

  deltaCompleteBanner = (
    hideIntroBanner,
    bannerConfig, $rootScope,
    baseRequestUrl, isAgnostic, codeProps,
    introEditorialContent, introConfig,
    isAuthenticated, showSignupModal,
    slug, Analytics
  ) => (
    <>
      <DeltaWifiBanner
        bannerConfig={bannerConfig}
        matchMedia={$rootScope.matchMedia}
        baseRequestUrl={baseRequestUrl}
        isAgnostic={isAgnostic}
        cityCode={codeProps}
      />
      {!hideIntroBanner
  && (
    <DeltaWifiIntroBanner
      baseRequestUrl={baseRequestUrl}
      editorialContent={introEditorialContent}
      introConfig={introConfig}
      isAgnostic={isAgnostic}
      isAuthenticated={isAuthenticated}
      login={this.login}
      showSignupModal={showSignupModal}
      slug={slug}
      analyticsEvent={Analytics?.event}
    />
  )}
    </>
  );

  render() {
    const {
      selectedTime, selectedDate, selectedSeats, isMobile, latLng,
      loadNotifyModal, locationCode, $rootScope,
      isAuthenticated, city,
      Analytics: { event },
      ResyAmexConfig: {
        baseRequestUrl,
      },
      Analytics,
      collections,
      showSignupModal,
      userIsGda,
      showAuthModal,
      agnosticCity,
    } = this.props;

    const {
      dataContent,
      slug,
    } = this.state;

    const renderLoading = (
      <div>
        <Loader className="DeltaWifi__loader" />
      </div>
    );

    const isAgnostic = this.isMarketAgnosticWithCity();
    if (latLng !== null && city && dataContent?.section) {
      const bannerConfig = dataContent?.section?.find((o) => o.name === 'banner');
      const bookNowConfig = dataContent?.section?.find((o) => o.name === 'booknow');
      const gdaBookNowConfig = dataContent?.section?.find((o) => o.name === 'gdabooknow');
      const footerConfig = dataContent?.section?.find((o) => o.name === 'footer');
      const citySelectorConfig = dataContent?.section?.find((o) => o.name === 'cityselector');
      const editorialConfig = dataContent?.section?.find((o) => o.name === 'editorial');
      const introConfig = dataContent?.section?.find((o) => o.name === 'introBanner');
      const algorithmicConfig = dataContent?.section?.find((o) => o.name === 'algorithmicList');
      const featuredVenuesConfig = dataContent?.section?.find((o) => o.name === 'featuredVenues');

      const { hide_section: hideBookNow } = isAgnostic ? bookNowConfig?.agnostic : bookNowConfig?.market;

      const { code: codeProps, name: nameProps } = city;
      const { code: codeState, name: nameState } = agnosticCity || {};

      // Intro banner
      const { hide_section: hideIntroBanner } = introConfig || {};

      // City Specific Editorial
      const { code_contents: codeContents } = !isAgnostic ? editorialConfig?.market : [];
      const cityEditorial = !isAgnostic ? codeContents?.find((c) => c.code === codeProps) : [];
      const { hide_section: hideCityEditorial } = cityEditorial || {};

      // Agnostic Editorials
      const { blogs } = isAgnostic ? editorialConfig?.agnostic : [];

      const blog1Editorial = isAgnostic ? blogs?.find((c) => c.id === 1) : {};
      const blog2Editorial = isAgnostic ? blogs?.find((c) => c.id === 2) : {};
      const blog3Editorial = isAgnostic ? blogs?.find((c) => c.id === 3) : {};

      const { hide_section: hideBlog1Editorial } = blog1Editorial || {};
      const { hide_section: hideBlog2Editorial } = blog2Editorial || {};
      const { hide_section: hideBlog3Editorial } = blog3Editorial || {};

      // City Specific Algorithmic
      const { code_contents: algorithmicCodeContents } = !isAgnostic ? algorithmicConfig?.market : [];
      const cityAlgorithmic = !isAgnostic ? algorithmicCodeContents?.find((c) => c.code === codeProps) : [];
      const { hide_section: hideCityAlgorithmic } = cityAlgorithmic || {};

      // Agnostic Featured Venues
      const featuredVenuesConfigData = isAgnostic ? featuredVenuesConfig?.agnostic : {};
      const { hide_section: hideFeaturedVenues } = featuredVenuesConfigData;

      // City logged in specific GDA Book Now
      const { code_contents: gdaBookNowCodeContents } = !isAgnostic ? gdaBookNowConfig?.market : [];
      const cityGdaBookNow = !isAgnostic ? gdaBookNowCodeContents?.find((c) => c.code === codeProps) : [];
      const { hide_section: hideCityGdaBookNow } = cityGdaBookNow || {};
      const showGDABookNow = !hideCityGdaBookNow && userIsGda;

      const blog1EditorialContent = this.getAgnosticEditorialContents(1);
      const blog2EditorialContent = this.getAgnosticEditorialContents(2);
      const blog3EditorialContent = this.getAgnosticEditorialContents(3);
      const marketEditorialContent = this.getMarketEditorialContents();
      const introEditorialContent = this.getIntroEditorialContents(isAgnostic);
      const deltaLogo = `${baseRequestUrl}DeltaWifi/bannerImages/${bannerConfig?.delta_logo}`;

      const selectedTimeValue = (selectedTime && selectedTime.length !== 0) ? selectedTime : ALL_DAY;

      return (
        <div className="DeltaWifi">
          {/** iPad ( Landscape & Portrait) and desktop */}
          { $rootScope.matchMedia.md && (
          <div className="DeltaWifi__deltaLogoBlock">
            {this.deltaCompleteBanner(
              hideIntroBanner,
              bannerConfig, $rootScope,
              baseRequestUrl, isAgnostic, codeProps,
              introEditorialContent, introConfig,
              isAuthenticated, showSignupModal,
              slug, Analytics
            )}
            <p className="DeltaWifi__deltaLogoBlock__text">{bannerConfig?.delta_logo_text}</p>
            <img
              src={deltaLogo}
              className="DeltaWifiBanner__logo"
              alt=""
            />
          </div>
          )}
          { !$rootScope.matchMedia.md && (
          <>
            {this.deltaCompleteBanner(
              hideIntroBanner,
              bannerConfig, $rootScope,
              baseRequestUrl, isAgnostic, codeProps,
              introEditorialContent, introConfig,
              isAuthenticated, showSignupModal,
              slug, Analytics
            )}
          </>
          )}
          {/* Agnostic Blog 1 Editorial */}
          {isAgnostic && !hideBlog1Editorial
          && blog1EditorialContent && (
            <DeltaWifiEditorial
              matchMedia={$rootScope.matchMedia}
              editorial={blog1Editorial}
              editorialContent={blog1EditorialContent}
              baseRequestUrl={baseRequestUrl}
              folderName="agnostic"
              blogNameOrCityCode="blog1"
              key="blog1"
              analyticsEvent={event}
            />
          )}
          {/* Agnostic Featured Venues */}
          {!hideFeaturedVenues && isAgnostic
          && (
          <DeltaWifiFeaturedVenues
            selectedDate={selectedDate}
            selectedSeats={selectedSeats}
            selectedTime={selectedTimeValue}
            featuredVenuesConfigData={featuredVenuesConfigData}
            analyticsEvent={event}
          />
          )}

          {(!hideBookNow && !isAgnostic && isAuthenticated && showGDABookNow) && (
          <DeltaWifiGDAVenues
            Analytics={Analytics}
            collectionList={collections}
            loadNotifyModal={loadNotifyModal}
            cityCode={codeProps}
            selectedDate={selectedDate}
            selectedSeats={selectedSeats}
            selectedTime={selectedTimeValue}
            isAuthenticated={isAuthenticated}
            cityName={nameProps}
            isMobile={isMobile}
            latLng={latLng}
            locationCode={locationCode}
            citySlug={slug}
            $rootScope={$rootScope}
            bookNowConfig={bookNowConfig}
            isAgnostic={isAgnostic}
            event={event}
            userIsGda={userIsGda}
            matchMedia={$rootScope.matchMedia}
            showAuthModal={showAuthModal}
          />
          )}

          {(!hideBookNow && isAgnostic) && (
          <DeltaWifiCitySelector
            fetchBookNowForAgnostic={this.fetchBookNowForAgnostic}
            citySelectorConfig={citySelectorConfig}
            analyticsEvent={event}
          />
          )}

          {((!hideBookNow && !isAgnostic && isAuthenticated && !showGDABookNow)
          || (!hideBookNow && !isAgnostic && !isAuthenticated)
          || (!hideBookNow && isAgnostic))
          && (
            <DeltaWifiBookNow
              cityName={nameProps || (isAgnostic && nameState)}
              cityCode={codeProps || (isAgnostic && codeState)}
              citySlug={slug}
              selectedDate={selectedDate}
              selectedSeats={selectedSeats}
              selectedTime={selectedTimeValue}
              isMobile={isMobile}
              latLng={latLng}
              loadNotifyModal={loadNotifyModal}
              locationCode={locationCode}
              $rootScope={$rootScope}
              isAuthenticated={isAuthenticated}
              bookNowConfig={bookNowConfig}
              matchMedia={$rootScope.matchMedia}
              isAgnostic={isAgnostic}
              event={event}
              Analytics={Analytics}
              showAuthModal={showAuthModal}
            />
          )}
          {/* City Specific Editorial */}
          {!isAgnostic && !hideCityEditorial
          && marketEditorialContent && (
            <DeltaWifiEditorial
              matchMedia={$rootScope.matchMedia}
              editorial={cityEditorial}
              editorialContent={marketEditorialContent}
              baseRequestUrl={baseRequestUrl}
              folderName="market"
              blogNameOrCityCode={codeProps}
              key={codeProps}
              analyticsEvent={event}
            />
          )}
          {/* Agnostic Blog 2 Editorial */}
          {isAgnostic && !hideBlog2Editorial
          && blog2EditorialContent && (
            <DeltaWifiEditorial
              matchMedia={$rootScope.matchMedia}
              editorial={blog2Editorial}
              editorialContent={blog2EditorialContent}
              baseRequestUrl={baseRequestUrl}
              folderName="agnostic"
              blogNameOrCityCode="blog2"
              key="blog2"
              analyticsEvent={event}
            />
          )}
          {/* Agnostic Blog 3 Editorial */}
          {isAgnostic && !hideBlog3Editorial
          && blog3EditorialContent && (
            <DeltaWifiEditorial
              matchMedia={$rootScope.matchMedia}
              editorial={blog3Editorial}
              editorialContent={blog3EditorialContent}
              baseRequestUrl={baseRequestUrl}
              folderName="agnostic"
              blogNameOrCityCode="blog3"
              key="blog3"
              analyticsEvent={event}
            />
          )}
          {!isAgnostic && !hideCityAlgorithmic && (
          <DeltaWifiAlgorithmicLists
            Analytics={Analytics}
            locationCode={codeProps}
            locationSlug={slug}
            selectedDate={selectedDate}
            selectedPartySize={selectedSeats}
          />
          )}
          <DeltaWifiFooter
            isAuthenticated={isAuthenticated}
            footerConfig={footerConfig}
            analyticsEvent={event}
            $rootScope={$rootScope}
          />
        </div>
      );
    }
    return renderLoading;
  }
}

const mapStateToProps = (state) => ({
  city: state.amexDeltaWifi?.city,
  userIsGda: selectIsGlobalDiningAccess(state),
  agnosticCity: state.amexDeltaWifi?.agnosticCity,
});

DeltaWifi.displayName = 'DeltaWifi';
export { DeltaWifi as ComponentDeltaWifiUnderTest };
export default connect(mapStateToProps)(DeltaWifi);
